import { registerSW } from 'virtual:pwa-register';

/**
 * Uygulama güncellemesi.
 *
 * Kurulu PWA eski sürümde takılı kalabiliyordu: yeni servis çalışanı devreye
 * girip dosyaları önbelleğe alıyor ama ekrandaki sayfa eski koddan çalışmaya
 * devam ediyordu, yani yeni sürümü görmek için uygulamayı iki kez kapatıp
 * açmak gerekiyordu. Sunucu protokolü değiştiğinde bu, eski istemcinin
 * takılması demek.
 *
 * Yenileme SAYFAYI YENİDEN YÜKLÜYOR, bu yüzden ne zaman yapıldığı önemli:
 * maçın ortasında yapılırsa bağlantı kopar ve koltuk bota geçer. Bu yüzden
 * güncelleme hazır olduğunda hemen uygulanmıyor; uygulamayı çağıran taraf
 * (masadan uzaktayken) `applyUpdate()` diyor.
 */

let ready = false;
let notify: (() => void) | null = null;

const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    ready = true;
    notify?.();
  },
});

/** Yeni sürüm hazır olduğunda haber verir (hazırsa hemen çağırır). */
export function onUpdateReady(listener: () => void): void {
  notify = listener;
  if (ready) listener();
}

/** Bekleyen güncellemeyi uygular — sayfayı yeniler. Masadayken çağrılmamalı. */
export function applyUpdate(): void {
  if (!ready) return;
  ready = false;
  void updateSW(true);
}
